import RecipeList from "@/components/Recipe/RecipeList";

export default function Recipe() {
  return (
    <section className="mr-20">
      <RecipeList /> {/* 레시피 목록 컴포넌트 */}
    </section>
  );
}
